'use strict';

var floatingTool = {
  handleEvents: function handleEvents() {
    // Open/close programs floating tool
    $('.fp-tool-toggle').on('click', function () {
      var $trigger = $(this);
      var $tool = $trigger.parents('.floating-programs-tool');
      var $content = $tool.find('.fp-content');
      var $slideIn = $tool.find('.fp-sliding-section');
      var isClosing = $trigger.toggleClass('closed').hasClass('closed');
      if (isClosing) {
        $slideIn.animate({
          'right': '-100%'
        }, 300, function () {
          $content.toggle(); // hide after sliding
        });
      } else {
        $slideIn.css('right', '-100%');
        $content.toggle(); // open before sliding
        $slideIn.animate({
          'right': '0'
        });
      }
    });

    // Load specific program, display items in program
    $('body').on('click', '.fp-program-item', function () {
      var $btn = $(this);
      var $tool = $btn.parents('.fp-content-inner');
      var url = $btn.attr('data-href');
      $tool.spinner('small').start();
      $.ajax({
        type: 'POST',
        url: url,
        success: function success(response) {
          if (response && response.success) {
            var $modal = $('#programModal');
            if ($modal.length !== 0) {
              $modal.remove();
            }
            $tool.spinner().stop();
            $('body').append(response.html);
            $('#programModal').modal('show');
          }
        },
        error: function error(_error) {
          console.error(_error);
          $tool.spinner().stop();
        }
      });
    });

    // Toggle removal confirmation view
    $('body').on('click', '.pi-toggle-removal', function () {
      var $btn = $(this);
      var $row = $btn.parents('.program-item-row');
      $row.toggleClass('confirm-removal');
    });

    // Confirm removal of program item, reload items afterward
    $('body').on('click', '.pi-remove-confirmed', function () {
      var $btn = $(this);
      var url = $btn.attr('data-href');
      var $modal = $('#programModal');
      var $itemRow = $btn.parents('.program-item-row');
      $itemRow.spinner('small').start();
      $.ajax({
        type: 'POST',
        url: url,
        success: function success(response) {
          if (response && response.success) {
            $modal.find('.program-item-list').replaceWith(response.html);
            $itemRow.spinner().stop();
          }
        },
        error: function error(_error2) {
          console.error(_error2);
          $itemRow.spinner().stop();
        }
      });
    });
  }
};
module.exports = floatingTool;